import axios from 'axios';

import { ChangePasswordForm } from '@/pages/change-password';

const BASE_ENDPOINT = `${process.env.NEXT_PUBLIC_API_URL}/account`;

const PASSWORD_ENDPOINT = `${BASE_ENDPOINT}/password`;

const REMIND_ENDPOINT = `${PASSWORD_ENDPOINT}/remind`;

function changePassword(data: ChangePasswordForm) {
    const url = new URL(PASSWORD_ENDPOINT);
    return axios.put(url.toString(), data);
}

function remindPassword(memberNumber: string) {
    const url = new URL(REMIND_ENDPOINT);
    url.searchParams.set('representativeNo', memberNumber);
    return axios.post(url.toString());
}

function resetPassword(hash: string, newPassword: string) {
    const url = new URL(`${REMIND_ENDPOINT}/reset`);
    const payload = {
        hash,
        newPassword
    };
    return axios.post(url.toString(), payload);
}

async function verifyRemindPasswordHash(hash: string) {
    const url = new URL(`${REMIND_ENDPOINT}/${hash}`);
    return axios.get(url.toString());
}

export const AccountService = {
    changePassword,
    remindPassword,
    resetPassword,
    verifyRemindPasswordHas: verifyRemindPasswordHash
};
